(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('pickJobGrpBatch', {
        templateUrl: 'views/components/views/pickJobGrpBatch/pickJobGrpBatch.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'pickJobGrpBatchService', function ($stateParams, stateService, utilityService, translateService, modalService, pickJobGrpBatchService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let stockTransferKeyno = $stateParams.stocktransfer_keyno;
            let runProgress = '';

            let progressInfo = {
                label: '',
                plabel: '',
                field: '',
                remField: '',
                min: 0,
                max: 100,
                step: 0,
                finishclose: ''
            };

            let translations = {
                error: '',
                ok: ''
            };

            vm.model = {
                gridReady: false,
                menu: {},
                activating: false,
                finishing: false,
                lockedRemove: false
            };

            vm.grid = {
                dataTask: {
                    rememberId: '',
                    loadSetupId: null,
                    loadData: {},
                    addRow: {
                        method: null,
                        parameters: null,
                        autoSave: false,
                        confirm: false
                    },
                    removeRow: {
                        method: null,
                        parameters: null,
                        autoSave: false,
                        confirm: false
                    },
                    saveData: {
                        method: null,
                        parameters: null,
                        autoSave: false,
                        confirm: false
                    }
                },
                translations: [],
                config: {
                    editColumns: [
                        { key: 'is_selected' }
                        /*'prod_name', 'stock_stockvalue', 'is_selected', { key: 'test_column', lookup: 1900, relations: [{ key: 'stockplace_name', value: 'item_id' }], optionfunc: true }, 'reg_date'*/
                    ],
                    toolbar: {
                        hidden: false,
                        pdfExport: true,
                        excelExport: true,
                        filter: true,
                        columnVisibility: true,
                        headers: true,
                        edit: false,
                        lock: false,
                        add: false,
                        delete: false,
                        save: false,
                        wrapping: true,
                        layouts: true,
                        buttons: [
                            //{ name: 'cancel', text: '', func: function () { console.log('this is a test with default icon'); } },
                            //{ name: 'test', text: '', func: function () { testItems(); } },
                            //{ name: 'customSave', text: '', func: function () { saveItems(); }, icon: 'save' },
                            //{ name: 'customAddBefore', text: '', func: function () { addItemBefore(); }, icon: 'insert-up' },
                            //{ name: 'customAddAfter', text: '', func: function () { addItemAfter(); }, icon: 'insert-down' },
                            //{ name: 'customDelete', text: '', func: function () { deleteItem(); }, icon: 'delete' }
                        ]
                    },
                    fixedHeader: true,
                    keepSortOnAdd: false,
                    keepSortOnCheckbox: false,
                    keepSortOnIsSelected: false,
                    rowClick: false,
                    specialFunc: {
                        newTab: true,
                        buttons: [
                            //{ name: 'test', text: '', func: function (data) { testItems(data); }, icon: 'far-star' }
                        ]
                    },
                    css: {
                        altColor: true,
                        textWrapping: false
                    },
                    onDataSourceChanges: function (e) {
                        //console.log('onDataSourceChanges');
                        //console.dir(e);
                    }
                },
                kendo: {
                    height: '100%',
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    //persistSelection: false,
                    filterable: false
                },
                optionfunc: null,
                gridfunc: null
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATE SERVICE

            async function translate() {
            	let data = await translateService.translateBatch(translations);

            	Object.keys(translations).forEach((key) => {
            		if (data?.[key]) translations[key] = data[key];
            	});
            }

            // #endregion TRANSLATE SERVICE

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadMenu() {
                vm.model.menu = (await pickJobGrpBatchService.getPickJobGrpBatch({ stocktransfer_keyno: stockTransferKeyno }))[0];
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region GRID PROCEDURE FUNCTION CALLS

            async function loadGrid() {
                if (utilityService.validateParmsValue(vm.model.menu.view_id) === true) {
                    vm.grid.dataTask.rememberId = vm.model.menu.view_id;
                }

                if (utilityService.validateParmsValue(vm.model.menu.p2_datatask_keyno) === true && utilityService.validateParmsValue(vm.model.menu.stocktransfer_keyno) === true) {
                    vm.grid.dataTask.loadData = {
                        method: vm.model.menu.p2_datatask_keyno,
                        parameters: { stocktransfer_keyno: vm.model.menu.stocktransfer_keyno }
                    };

                    vm.model.gridReady = true;

                    if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
                }
            }

            // #endregion GRID PROCEDURE FUNCTION CALLS

            // #region MULTI DIRECTION BUTTON FUNCTIONS

            vm.goToFunc = function (state, e) {
                function go(parms) {
                    if (e?.ctrlKey) {
                        stateService.newTab(state, parms);
                    } else {
                        stateService.go(state, parms);
                    }
                }

                switch (state) {
                    case 'pickjobgrpbatchaddo':
                    case 'pickjobgrpbatchaddr':
                        go({ stocktransfer_keyno: vm.model.menu.stocktransfer_keyno });
                        break;
                    default:
                        break;
                }
            };

            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

            // #region BUTTON ACTIVATE PROCEDURE FUNCTION CALL

            vm.activateChanges = function () {
                vm.model.activating = true;

                pickJobGrpBatchService.activateStockTransfer({ stocktransfer_keyno: vm.model.menu.stocktransfer_keyno }).then((response) => {
                    if (response[0] && response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: (dialogItself) => {
                                    dialogItself.close();
                                    vm.model.activating = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.activating = false;
                        stateService.back();
                    }
                });
            }

            vm.finishChanges = function () {
                vm.model.finishing = true;

                pickJobGrpBatchService.setFinished({ stocktransfer_keyno: vm.model.menu.stocktransfer_keyno }).then((response) => {
                    if (response[0] && response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: (dialogItself) => {
                                    dialogItself.close();
                                    vm.model.finishing = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.finishing = false;
                        stateService.back();
                    }
                });
            }

		    // #endregion BUTTON ACTIVATE PROCEDURE FUNCTION CALL

            // #region SHOW PROGRESSBAR DIALOGUE BOX FUNCTION

            function activateProgress(items) {
                let increment = 1, skip = 0, failed = 0, step = 0;
                progressInfo.step = 0;

                function doStep() {
                    setTimeout(() => {
                        modalService.progressInfo.finishclose = '0';

                        if (runProgress === 'ABORT') return;

                        if (progressInfo.step >= progressInfo.max) {
                            return;
                        }

                        step = progressInfo.step + skip + failed;
                        progressInfo.field = 'ID: ' + items[step].consignment_keyno;
                        modalService.progressInfo.field = progressInfo.field;

                        pickJobGrpBatchService.removeItems({
                            stocktransfer_keyno: vm.model.menu.stocktransfer_keyno,
                            consignment_keyno: items[step].consignment_keyno
                        }).then((response) => {
                            if (response[0] && response[0].errorcode !== '0') {
                                modalService.show({
                                    type: 'warning',
                                    title: translations.error,
                                    message: response[0].errormessage,
                                    buttons: [{
                                        label: translations.ok,
                                        cssClass: 'btn-warning',
                                        action: (dialogItself) => {
                                            dialogItself.close();
                                            vm.model.lockedRemove = false;
                                            modalService.progressInfo.finishclose = '1';
                                            runProgress = 'ABORT';
                                            modalService.progressInfo.abortclose = true;

                                            doStep();
                                        }
                                    }]
                                });
                            } else {
                                progressInfo.step += increment;
                                modalService.progressInfo.step = progressInfo.step;
                                modalService.progressInfo.finishclose = progressInfo.finishclose;

                                doStep();
                            }
                        });
                    });
                }

                doStep();
            }

            vm.removeSelected = function () {
                vm.model.lockedRemove = true;
                runProgress = 'START';
                progressInfo.label = 'progressbar';
                //progressInfo.plabel = 'progressbar';
                progressInfo.field = '';
                //progressInfo.remField = '';
                //progressInfo.min = 0;
                progressInfo.max = 0;
                progressInfo.step = 0;
                progressInfo.finishclose = '1';
                progressInfo.abortclose = false;

                let allData = vm.grid.gridfunc.getAllRows();
                let currentData = [];

                allData.forEach((item) => {
                    if (item.is_selected && item.is_selected === true) {
                        currentData.push(item);
                    }
                });

                progressInfo.max = currentData.length;
                activateProgress(currentData);

                modalService.showProgress(progressInfo).then(function (value) {
                    runProgress = value;

                    if (runProgress === 'ABORT') {
                        vm.model.lockedRemove = false;
                        loadGrid();
                    } else if (runProgress === 'FINISH') {
                        vm.model.lockedRemove = false;
                        loadGrid();
                    }
                });
            }

            // #endregion SHOW PROGRESSBAR DIALOGUE BOX FUNCTION

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
                translate();
                await loadMenu();
                loadGrid();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
